<script setup lang="ts">
import { computed } from 'vue';
import type { ContactLabel } from '@apparatix/types/Leads';

const props = withDefaults(defineProps<{ label: ContactLabel | string, size?: 'small' | 'regular', customColor?: string }>(), {
  size: 'regular',
  customColor: '',
});

const label = computed(() => {
  if (typeof props.label === 'string') {
    return props.label;
  }
  return props.label.contactLabelDisplayName;
});

const chipColors = computed(() => {
  if (props.customColor) {
    return [props.customColor, '#FFFFFF'];
  }

  switch (label.value) {
    case 'Primary':
      return ['#E3E1FF', '#4F46E5'];
    case 'Signer':
      return ['#FFE58A', '#995C00'];
    case 'Bill To':
      return ['#C4EFE0', '#2B9C74'];
    case 'Bill-To':
      return ['#C4EFE0', '#2B9C74'];
    case 'Gatekeeper':
      return ['#FFD2DA', '#D34354'];
    case 'Agency':
      return ['#FFD2DA', '#D34354'];
    case 'Previous Advertiser':
    case 'Prospective Advertiser':
    case 'Advertiser':
      return ['#CEEDFF', '#2E9BD8'];
    case 'PoP':
      return ['#CEEDFF', '#126797'];
    default:
      return ['var(--light-neutral-background)', 'var(--swimlane-primary-text)'];
  }
});
</script>
<template>
  <div
    class="inline-flex items-center justify-center py-1 uppercase text-xs rounded-full leading-none"
    :style="{background: chipColors[0], color: chipColors[1]}"
    :class="[props.size === 'regular' ? 'px-2 font-bold' : 'px-1.5 font-normal']"
  >
    {{ label }}
  </div>
</template>
